module.exports = __webpack_public_path__ + "6953daaf62be3d9f3ad88f4df8feac32.jpg";